import actionTypes from '../constants/actionTypes';

export function recordKeyCopyToClipboardSuccess(payload) {
    return {
        type: actionTypes.RECORD_KEY_COPY_TO_CLIPBOARD_SUCCESS,
        payload
    }
}

/**
 * Records Search Form
 */
export function recordSearchFormChange(payload) {
    return {
        type: actionTypes.RECORD_SEARCH_FORM_CHANGE,
        payload
    }
}

export function recordSearchFormReset() {
    return {
        type: actionTypes.RECORD_SEARCH_FORM_RESET
    }
}


/**
 * Records Add Form
 */
export function recordAddFormChange(record) {
    return {
        type: actionTypes.RECORD_ADD_FORM_CHANGE,
        payload: record
    }
}

export function recordAddFormReset() {
    return {
        type: actionTypes.RECORD_ADD_FORM_RESET
    }
}

function recordAddFormSubmitError(payload) {
    return {
        type: actionTypes.RECORD_ADD_FORM_SUBMIT_ERROR,
        payload
    }
}

function recordAddFormSubmitStart() {
    return {
        type: actionTypes.RECORD_ADD_FORM_SUBMIT_START
    }
}

function recordAddFormSubmitSuccess(payload) {
    return {
        type: actionTypes.RECORD_ADD_FORM_SUBMIT_SUCCESS,
        payload
    }
}


/**
 * Records Edit Form
 */
export function recordEditFormChange(record) {
    return {
        type: actionTypes.RECORD_EDIT_FORM_CHANGE,
        payload: record
    }
}

export function recordEditFormReset() {
    return {
        type: actionTypes.RECORD_EDIT_FORM_RESET
    }
}

function recordEditFormSubmitError(payload) {
    return {
        type: actionTypes.RECORD_EDIT_FORM_SUBMIT_ERROR,
        payload
    }
}

function recordEditFormSubmitStart() {
    return {
        type: actionTypes.RECORD_EDIT_FORM_SUBMIT_START
    }
}

function recordEditFormSubmitSuccess(payload) {
    return {
        type: actionTypes.RECORD_EDIT_FORM_SUBMIT_SUCCESS,
        payload
    }
}

function recordDeleteFormSubmitError(payload) {
    return {
        type: actionTypes.RECORD_DELETE_FORM_SUBMIT_ERROR,
        payload
    }
}

function recordDeleteFormSubmitStart() {
    return {
        type: actionTypes.RECORD_DELETE_FORM_SUBMIT_START
    }
}

function recordDeleteFormSubmitSuccess(payload) {
    return {
        type: actionTypes.RECORD_DELETE_FORM_SUBMIT_SUCCESS,
        payload
    }
}


/**
 * Records Fetching
 */
function recordsFetchingStart() {
    return {
        type: actionTypes.RECORDS_FETCHING_START
    }
}

function recordsFetchingNoResult(payload) {
    return {
        type: actionTypes.RECORDS_FETCHING_NO_RESULT,
        payload
    }
}

function recordsFetchingSuccess(payload) {
    return {
        type: actionTypes.RECORDS_FETCHING_SUCCESS,
        payload
    }
}

function recordsFetchingError(payload) {
    return {
        type: actionTypes.RECORDS_FETCHING_ERROR,
        payload
    }
}

export function submitSearchAllRecord() {
    var token = localStorage.getItem('token') || null;

    return dispatch => {
        dispatch(recordsFetchingStart());

        return fetch(`${process.env.REACT_APP_SERVICE_KEYS_CLIENT_API_URL}/records`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            mode: 'cors'
        })
            .then((response) => {
                if (response.ok) {
                    return response.json();
                }

                switch (response.status) {
                    case 401:
                        throw new Error('Ошибка авторизации');
                    case 403:
                        throw new Error('Недостаточно прав');
                        break;
                    default:
                        throw new Error(response.statusText);
                }
            })
            .then((response) => {
                if (!response.success) {
                    throw new Error('Ошибка получения записей');
                } else {
                    return response;
                }
            })
            .then((data) => {
                let coincidence_ar_lable = ['mb', 'cpu', 'hdd', 'ram'];

                data.data = data.data.map((item, i) => {
                    item['coincidence'] = '-';
                    let server_article_ar = item['server_article'].split('-');
                    let server_article_ar_result = [];

                    server_article_ar.forEach((item, i) => {
                        server_article_ar_result.push({
                            article_part: item,
                            coincidence: false,
                            label: coincidence_ar_lable[i],
                            check_coincidence: false
                        })
                    });

                    item['server_article'] = server_article_ar_result;
                    return item;
                });

                dispatch(recordsFetchingSuccess(data.data));
                if (data.data.length === 0)
                    dispatch(recordsFetchingNoResult(data.data));
            })
            .catch((error) => {
                dispatch(recordsFetchingError(error.message));
            })
    }
}

export function submitSearchRecord(data) {
    var token = localStorage.getItem('token') || null;
    var params = data;
    return dispatch => {
        dispatch(recordsFetchingStart());

        return fetch(`${process.env.REACT_APP_SERVICE_KEYS_CLIENT_API_URL}/records/search`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            mode: 'cors',
            body: JSON.stringify(data)
        })
            .then((response) => {
                if (response.ok) {
                    return response.json();
                }

                switch (response.status) {
                    case 401:
                        throw new Error('Ошибка авторизации');
                    case 403:
                        throw new Error('Недостаточно прав');
                        break;
                    default:
                        throw new Error(response.statusText);
                }

            })
            .then((response) => {
                if (!response.success) {
                    throw new Error('Ошибка получения записей ' + response.data);
                } else {
                    return response;
                }
            })
            .then((data) => {
                data.data = data.data.map((item) => {

                    let coincidence = 0;
                    let server_article_ar_result = [];
                    let check_coincidence = (params.hid && params.serial_number || params.search_type == 'by_config') || false;

                    if (item.server_article) {
                        let server_article_ar = item.server_article.split('-')
                        let server_article_requested = item.server_article_requested ? item.server_article_requested.split('-') : [];

                        let coincidence_ar = [50, 17, 17, 17];
                        let coincidence_ar_lable = ['mb', 'cpu', 'hdd', 'ram'];

                        server_article_ar.forEach((item, i) => {
                            coincidence += item == server_article_requested[i] ? coincidence_ar[i] : 0;
                            server_article_ar_result.push({
                                article_part: item,
                                coincidence: item == server_article_requested[i] && check_coincidence ? true : false,
                                label: coincidence_ar_lable[i],
                                check_coincidence: check_coincidence
                            })
                        });

                        if (coincidence > 100) coincidence = 100;
                        if (!check_coincidence) coincidence = '-';
                    }

                    item['coincidence'] = coincidence;
                    item['server_article'] = server_article_ar_result;

                    item['server_article_requested'] = item.server_article_requested
                        ? item.server_article_requested
                        : '-';

                    return item;
                });

                dispatch(recordsFetchingSuccess(data.data));

                if (data.data.length === 0)
                    dispatch(recordsFetchingNoResult(data.data));
            })
            .catch((error) => {
                dispatch(recordsFetchingError(error.message));
            })
    }
}

export function submitAddRecord(data) {
    var token = localStorage.getItem('token') || null;

    return dispatch => {
        dispatch(recordAddFormSubmitStart());

        return fetch(`${process.env.REACT_APP_SERVICE_KEYS_CLIENT_API_URL}/records`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(data),
            mode: 'cors'
        })
            .then((response) => {
                if (response.ok) {
                    return response.json();
                }

                switch (response.status) {
                    case 401:
                        throw new Error('Ошибка авторизации');
                    case 403:
                        throw new Error('Недостаточно прав');
                    case 409:
                        throw new Error('Запись с таким HID уже существует в базе');
                    default:
                        throw new Error(response.statusText);
                }
            })
            .then((response) => {
                if (!response.success) {
                    throw new Error('Ошибка добавления записи ' + response.data);
                } else {
                    return response;
                }
            })
            .then((data) => {
                dispatch(recordAddFormSubmitSuccess(data.data));
                dispatch(submitSearchAllRecord());
            })
            .catch((error) => {
                dispatch(recordAddFormSubmitError(error.message));
            })
    }
}

export function submitEditRecord(data) {
    var token = localStorage.getItem('token') || null;

    return dispatch => {
        dispatch(recordEditFormSubmitStart());

        return fetch(`${process.env.REACT_APP_SERVICE_KEYS_CLIENT_API_URL}/records`, {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(data),
            mode: 'cors'
        })
            .then((response) => {
                if (response.ok) {
                    return response.json();
                }

                switch (response.status) {
                    case 401:
                        throw new Error('Ошибка авторизации');
                    case 403:
                        throw new Error('Недостаточно прав');
                        break;
                    default:
                        throw new Error(response.statusText);
                }
            })
            .then((response) => {
                if (!response.success) {
                    throw new Error('Ошибка редактирования записи ' + response.data);
                } else {
                    return response;
                }
            })
            .then((response) => {
                dispatch(recordEditFormSubmitSuccess(data));
                dispatch(submitSearchAllRecord());
            })
            .catch((error) => {
                dispatch(recordEditFormSubmitError(error.message));
            })
    }
}

export function submitDeleteRecord(data) {
    var token = localStorage.getItem('token') || null;
    return dispatch => {
        dispatch(recordDeleteFormSubmitStart());

        return fetch(`${process.env.REACT_APP_SERVICE_KEYS_CLIENT_API_URL}/records`, {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(data),
            mode: 'cors'
        })
            .then((response) => {
                if (response.ok) {
                    return response.json();
                }

                switch (response.status) {
                    case 401:
                        throw new Error('Ошибка авторизации');
                    case 403:
                        throw new Error('Недостаточно прав');
                    default:
                        throw new Error(response.statusText);
                }
            })
            .then((response) => {
                if (!response.success) {
                    throw new Error('Ошибка удаления записи ' + response.data);
                } else {
                    return response;
                }
            })
            .then((response) => {
                dispatch(recordDeleteFormSubmitSuccess(data));
                dispatch(submitSearchAllRecord());
            })
            .catch((error) => {
                dispatch(recordsFetchingError(error.message));
            })

    }
}

/**
 * Modal Add actions
 */

export function recordsAddModalOpen(payload) {
    return {
        type: actionTypes.RECORD_ADD_MODAL_OPEN,
        payload: {
            visible: true,
            hidden_data: payload.hidden_data,
            hid: payload.hid || '',
            serial_number: payload.serial_number || '',
            validation: {
                hid: '',
                serial_number: ''
            }
        }
    }
}

export function recordAddModalChange(payload) {
    return {
        type: actionTypes.RECORD_ADD_MODAL_CHANGE,
        payload
    }
}

export function recordsAddModalClose() {
    return {
        type: actionTypes.RECORD_ADD_MODAL_CLOSE,
    }
}

export function submitAddRecordModal(data) {
    return dispatch => {
        dispatch(submitAddRecord(data));
    }
}

export function submitDeleteRecordModal(data) {
    return dispatch => {
        dispatch(submitDeleteRecord(data));
    }
}

/**
 * Modal Edit actions
 */

export function recordsEditModalOpen(payload) {
    return {
        type: actionTypes.RECORD_EDIT_MODAL_OPEN,
        payload: {
            id: payload._id,
            visible: true,
            hidden_data: payload.hidden_data || '',
            hid: payload.hid || '',
            comments: payload.comments || '',
            serial_number: payload.serial_number || '',
            validation: {
                hid: '',
                serial_number: ''
            }
        }
    }
}

export function recordEditModalChange(payload) {
    return {
        type: actionTypes.RECORD_EDIT_MODAL_CHANGE,
        payload
    }
}

export function recordsEditModalClose() {
    return {
        type: actionTypes.RECORD_EDIT_MODAL_CLOSE,
    }
}

export function submitEditRecordModal(data) {
    return dispatch => {
        dispatch(submitEditRecord(data));
    }
}




// WEBPACK FOOTER //
// ./src/actions/recordsActions.js